import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import Clarity from '@microsoft/clarity';
import 'swiper/css';
import 'swiper/css/effect-fade';
import './Hero.css';

const Hero: React.FC = () => {
  const swiperRef = useRef<SwiperType | null>(null);

  const handleLeftTap = () => {
    Clarity.event('hero_slide_previous');
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleRightTap = () => {
    Clarity.event('hero_slide_next');
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const scrollToNext = () => {
    Clarity.event('hero_scroll_to_discover');
    const storytellingSection = document.getElementById('storytelling');
    if (storytellingSection) {
      storytellingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-container">
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect="fade"
        fadeEffect={{
          crossFade: true
        }}
        speed={800}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        allowTouchMove={true}
        onSwiper={(swiper: SwiperType) => {
          swiperRef.current = swiper;
        }}
        className="hero-swiper"
      >
        {/* Slide 1: Polaroid Frame Image */}
        <SwiperSlide className="hero-slide slide-1">
          <div className="slide-content">
            <div className="polaroid-frame">
              <div className="polaroid-image">
                <img 
                  src="https://pratham-public-bucket.s3.us-east-1.amazonaws.com/1754712959220~2.jpg" 
                  alt="Poppy Photography" 
                  className="polaroid-photo"
                />
              </div>
              <div className="polaroid-caption">
                <span className="text-script">For the blinks you might miss</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2: Background Image with Overlay and Tagline */}
        <SwiperSlide className="hero-slide slide-2">
          <div className="slide-content">
            <div className="slide-overlay"></div>
            <div className="slide-text">
              <h1 className="hero-title">Poppy</h1>
              <p className="hero-tagline text-script">While you live the moments, we preserve them beautifully</p>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3: Background Video with CTA */}
        <SwiperSlide className="hero-slide slide-3">
          <div className="slide-content">
            <video 
              className="hero-background-video"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="https://pratham-public-bucket.s3.us-east-1.amazonaws.com/1755524093710.mp4" type="video/mp4" />
            </video>
            <div className="slide-overlay"></div>
            <div className="slide-text">
              <div className="cta-container">
                <p className="text-script scroll-cta" onClick={scrollToNext}>
                  Scroll Down to Discover
                </p>
                <div className="scroll-arrow" onClick={scrollToNext}>
                  <span>↓</span>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* Touch Navigation Zones */}
      <div className="touch-nav-left" onClick={handleLeftTap}></div>
      <div className="touch-nav-right" onClick={handleRightTap}></div>
    </div>
  );
};

export default Hero;